 /*============ Timed Content Controller
  ================================*/
 angular.module("vppApp").controller("timedContentController", timedContentController);

 timedContentController.$inject = [
   "$scope",
   "timedContentFactory", '$element', '$attrs'
 ];

 function timedContentController($scope, timedContentFactory, $element, $attrs) {

   timedContentFactory().then(function(response) {
     var data = response.data.content;

     if (data) {
       var itemId = $attrs.itemId;
       for (var i = 0; i < data.length; i++) {
         var thisId = data[i].id;
         if (thisId === itemId) {
           var thisEnd = data[i].endDate;
           var thisEndTime = parseInt(data[i].endTime);
           var endTime = thisEnd + ' ' + thisEndTime + ':00:00';
           var thisStart = data[i].startDate;
           var thisStartTime = parseInt(data[i].startTime);
           var startTime = thisStart + ' ' + thisStartTime + ':00:00';
           var startDate = new Date(startTime);
           var endDate = new Date(endTime);
           var currentDate = new Date();
           if (endDate > currentDate && startDate < currentDate) {

             //  if (environment !== "PROD" && data[i].preprod === 'true' || environment === "PROD") {
             //assign object to scope
             $scope.directId = itemId;
             $scope.jsonId = thisId;
             $scope.item = data[i];
             //  }
             console.log('valid date');
             break;
           }

         }
       }
     } else {
       return
     }






   });
 }
